import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { PaginatedServicesList, Services } from "../../app/generated-axios-client";

export interface ServicesState {
  list: PaginatedServicesList;
  service: Services | null;
}

const initialState: ServicesState = {
  list: {
    pagination: {
      total_items: 0,
      total_pages: 0,
      current_page: 0,
      per_page: 0,
    },
    results: [],
  },
  service: null,
};

export const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    addServiceList: (state, action: PayloadAction<PaginatedServicesList>) => {
      state.list = action.payload;
    },
    storeService: (state, action: PayloadAction<Services>) => {
      state.service = action.payload;
    },
    removeService: (state) => {
      state.service = null;
    },
    addOrUpdateService: (_state, _action: PayloadAction<Services>) => {},
    deleteService: (_state, _action: PayloadAction<string>) => {},
  },
});

export const servicesActions = servicesSlice.actions;
export const servicesReducer = servicesSlice.reducer;
export default servicesReducer;
